import { AfterContentInit, Component, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Employee } from '../../../../../_interfaces/employee.interface';
import { EmployeeApiService } from '../../../../../_services/employee-service/api/employee-api.service';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';
import { ToastService } from '../../../../../_services/toast-service/toast.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { BoFormsModule } from '@bo/ng-forms';
import { SelectOption } from '../../../../../_interfaces/select-field.interface';
import { Subscription } from 'rxjs';
import { OffcanvasCancelBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-cancel-btn/offcanvas-cancel-btn.component';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';

@Component({
  selector: 'app-remove-admin',
  imports: [
    NgbTooltip,
    LoaderComponent,
    NgSelectModule,
    BoFormsModule,
    OffcanvasCancelBtnComponent,
    OffcanvasBaseComponent,
  ],
  templateUrl: './remove-approver.component.html',
})
export class RemoveApproverComponent implements AfterContentInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  readonly employeeApiService = inject(EmployeeApiService);
  readonly offcanvasService = inject(OffcanvasService);
  readonly toastService = inject(ToastService);

  employeeId!: string;
  protected returnUrl: string = '/employees';
  public readonly approverOptions: Array<SelectOption> = [];
  public selectedReplacement!: string;
  protected employeeFullName: string | undefined;
  readonly subscriptions = new Subscription();

  constructor() {
    this.route.params.subscribe({
      next: (params: Params) => {
        this.employeeId = params['id'];
      },
    });
  }

  ngAfterContentInit(): void {
    this.loadEmployeeDetails();
    this.getApproverOptions();
  }

  getApproverOptions() {
    this.subscriptions.add(
      this.employeeApiService.getAllEmployees().subscribe({
        next: (employees: Employee[]) => {
          const filteredEmployees: Employee[] = employees.filter(
            (employee: Employee) => employee.id !== this.employeeId,
          );
          for (const employee of filteredEmployees) {
            this.approverOptions.push({
              option: employee.first_name + ' ' + employee.last_name,
              value: employee.id,
            });
          }
        },
      }),
    );
  }

  loadEmployeeDetails() {
    this.subscriptions.add(
      this.employeeApiService.getEmployeeById(this.employeeId).subscribe({
        next: (employee: Employee) => {
          this.employeeFullName = `${employee.first_name} ${employee.last_name}`;
        },
      }),
    );
  }

  onReplaceApprover() {
    this.subscriptions.add(
      this.employeeApiService.replaceEmployeeApprover(this.employeeId, this.selectedReplacement).subscribe({
        next: () => {
          this.employeeApiService.removeEmployee(this.employeeId).subscribe({
            next: () => {
              this.offcanvasService.close();
              this.offcanvasService.offCanvasNavigate('/employees');
            },
            complete: () => {
              this.toastService.show(`You have successfully removed an employee`, 'iconoir-check-circle');
            },
            error: () => {
              this.toastService.show('Something went wrong. This employee could not be removed.');
            },
          });
        },
        error: () => {
          this.toastService.show('Something went wrong. This approver could not be replaced.');
        },
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
